import axios from 'axios';

import { PAGE_SIZES } from '../../constants';

export const getRemovedLogs = (pagination) => axios.get(
    `${process.env.REACT_APP_API_URL}/logs`,
    {
        params: {
            'page[number]': pagination.number,
            'page[size]': PAGE_SIZES.LOGS,
            action: 'remove',
        },
    },
);
